import { EnergyType } from "../types/energyType"
import { SubscriptionFunnelType } from "../types/funnelType"
import { type SelectedEnergyTypes } from "../types/selectedEnergyTypes"
import { isDualEnergy } from "./isDualEnergy"
import { isGasOnly } from "./isMonoEnergy"

export function mapFunnelTypeToEnergyTypes(funnelType: SubscriptionFunnelType): EnergyType[] {
    switch (funnelType) {
        case SubscriptionFunnelType.MonoEnergyElectricity:
            return [EnergyType.Electricity]
        case SubscriptionFunnelType.MonoEnergyGas:
            return [EnergyType.Gas]
        case SubscriptionFunnelType.DualEnergy:
            return [EnergyType.Electricity, EnergyType.Gas]
        default:
            return [EnergyType.Electricity]
    }
}

export function mapEnergyTypesToFunnelType(
    selectedEnergyTypes: SelectedEnergyTypes
): SubscriptionFunnelType {
    if (isDualEnergy(selectedEnergyTypes)) {
        return SubscriptionFunnelType.DualEnergy
    }

    if (isGasOnly(selectedEnergyTypes)) {
        return SubscriptionFunnelType.MonoEnergyGas
    }

    return SubscriptionFunnelType.MonoEnergyElectricity
}
